import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ISwapCountByDex } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

async function getDexSwapCountCumulativeConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_swap_count_by_dex', timeframe)) as ISwapCountByDex[]

	const thorswapData = chartData.filter((row) => row.LABEL === 'THORSwap')
	const thorwalletData = chartData.filter((row) => row.LABEL === 'THORWallet')
	const trustwalletData = chartData.filter((row) => row.LABEL === 'Trustwallet')
	const asgardexData = chartData.filter((row) => row.LABEL === 'Asgardex')
	const shapeshiftData = chartData.filter((row) => row.LABEL === 'ShapeShift')
	const othersData = chartData.filter((row) => row.LABEL === 'Others')
	const ledgerData = chartData.filter((row) => row.LABEL === 'Ledger')
	const vultisigData = chartData.filter((row) => row.LABEL === 'Vultisig')
	const bitgetData = chartData.filter((row) => row.LABEL === 'Bitget')
	const tcSwapData = chartData.filter((row) => row.LABEL === 'TCSwap')
	const series1 = thorswapData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series2 = thorwalletData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series3 = trustwalletData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series4 = asgardexData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series5 = shapeshiftData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series6 = othersData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series7 = bitgetData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series8 = ledgerData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series10 = vultisigData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const series12 = tcSwapData.map((element: ISwapCountByDex) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.CUMULATIVE_SWAP_COUNT }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'THORSwap',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[0]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'TrustWallet',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[1]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'Ledger',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[2]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},

		{
			data: series2,
			strokeWidth: 2,
			name: 'THORWallet',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[3]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'BitgetWallet',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[4]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'ShapeShift',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[5]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'Asgardex',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[6]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},
		{
			data: series10,
			strokeWidth: 2,
			name: 'Vultisig',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[7]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},
		{
			data: series12,
			strokeWidth: 2,
			name: 'TCSwap',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[9]}`,
			unitSymbol: '',
			barGroup: 'positive'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'Others',
			type: 'bars',
			seriesGroup: '[swap #]',
			color: `${colors[8]}`,
			unitSymbol: '',
			barGroup: 'positive'
		}
	]

	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const DexSwapCountCumulative = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getDexSwapCountCumulativeConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Total Swap Count by Affiliate"
			chartDesc="Cumulated number of swaps routed through each affiliate partner."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="d16cd8f3-39a4-4789-b5ba-e66179d75412"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default DexSwapCountCumulative
